<template>
  <div class="mob-remove-table-fixed">
    <Card shadow>
      <Row>
        <Col style="text-align: right">
          <Button
            style="float: right;"
            @click="$router.push({ name: 'systemUserReviewAdd' })"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">申请</Button>
        </Col>
        <Divider/>
        <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
          <FormItem label="标题">
            <Input v-model="tableSearchForm.title" style="min-width: 200px" />
          </FormItem>
          <FormItem label="申请人">
            <Select v-model="tableSearchForm.ops_user_id" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker type="daterange" placement="bottom-end" placeholder=""
                        v-model="tableSearchForm.created_at"
                        style="min-width: 200px"
                        @on-change="searchApplicationTimeChange"
                        class="mob-w-100"></DatePicker>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getTableData()">搜索</Button>
            <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"
        @on-sort-change="changeSort"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getSystemUserReview, deleteSystemUserReview } from '@/api/workflow/system_user_review'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'
export default {
  name: 'SystemUserReviewList',
  data () {
    let that = this
    return {
      status: null,
      ordering: null,
      tableLoading: false,
      listError: false,
      table: {
        data: [],
        columns: [
          {
            title: '标题',
            key: 'title',
            align: 'center',
            tooltip: true,
            minWidth: 300
          },
          {
            title: '申请人',
            key: 'ops_user_dict',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.ops_user_dict.name ? params.row.ops_user_dict.name : params.row.ops_user_dict.username)
            }
          },
          {
            title: '申请时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            sortable: 'custom',
            render: (h, params) => {
              if (params.row.status) {
                return h('Tag', {
                  props: {
                    color: params.row.status === '已完成' ? 'green' : 'blue'
                  }
                }, params.row.status)
              } else {
                return ''
              }
            },
            filterMultiple: false,
            filterRemote (value, row) {
              if (value.length > 0) {
                that.status = value[0]
              } else {
                that.status = null
              }
              that.getTableData()
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'systemUserReviewDetail', params: { id: params.row.id }, query: { id: params.row.id, lastPage: this.table.page } })
                    }
                  }
                }, '详情'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: this.$store.state.user.superuser || this.$store.state.user.userId ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      tableSearchForm: {
        title: '',
        ops_user_id: undefined,
        created_at: ''
      },
      userList: [],
      moment: moment
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getAllUserData()
  },
  methods: {
    changeSort (column) {
      if (column.key === 'status_verbose') {
        if (column.order === 'asc') {
          this.ordering = 'status'
        } else {
          this.ordering = '-status'
        }
      }
      this.getTableData()
    },
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      let reqParams = {
        size: this.table.size,
        page: this.table.page,
        title: this.tableSearchForm.title,
        // created_at: this.tableSearchForm.created_at,
        status: this.status,
        ops_user: this.tableSearchForm.ops_user_id
      }
      getSystemUserReview(reqParams).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (id) {
      deleteSystemUserReview(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        title: '',
        created_at: ''
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },

    searchApplicationTimeChange (value) {
      this.tableSearchForm.created_at_after = value[0]
      this.tableSearchForm.created_at_before = value[1]
    }
  }
}
</script>

<style scoped>

</style>
